import React, { useContext, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { FoodContext } from "../../../../../contexts/Food";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const WastageFoodView = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const params = useParams();
    const { roundOffStock, qtyAmountPoints } = useCustomHooks();
    //getting context values here
    let {
      loading,
      setLoading,
      branchForSearch,
      branchForListSearch,
    } = useContext(RestaurantContext);
   
    const { foodForPOS, propertyItemList } = useContext(FoodContext)

    // States hook here
    //new item
    let [newWastage, setNewWastage] = useState({
      documentDate: new Date,
      branch:null,
      variation:'',
      type:'',
      document_no:'',
      qty: 1,
    });    
  

    //selected items states
    const [property, setProperty] = useState(null);
    const [food, setFood] = useState(null);

    //variation
    const [showVariation, setShowVariation] = useState(false);

    //radio item
    const [optionType, setOptionType] = useState(null);
    const [optionFG, setOptionFG] = useState(null);

    //new Row
    const [newRow,setNewRow]=useState([]);

    const getSpecificWastage = async () => {
        setLoading(true);
        const url =
        BASE_URL + "/settings/signal-stock-wastage/" +
        parseInt(params.id);
        try {
        const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
          if(res){
            const wastageItem = res.data;
            if(wastageItem && wastageItem !== null){
              const documentDate= new Date(wastageItem?.document_date);
              const branch= branchForListSearch[wastageItem?.branch_id];
              if(wastageItem.type === "food"){
                const foodItem = foodForPOS?.find((item)=> item.id === wastageItem.item_id);
                setOptionFG("food_item");
                setFood(foodItem)
              }else if(wastageItem.type === "property"){
                const propertyItem = propertyItemList?.find((item)=> item.id === wastageItem.item_id);
                setOptionFG("property_item");
                setProperty(propertyItem)
              }
              
              setNewWastage({
                ...newWastage,
                document_no:wastageItem?.document_identity,
                documentDate,
                variation:wastageItem?.variation_name,
                branch,
                remarks:wastageItem.remarks,
                qty: wastageItem?.qty || 1,
              })
              setOptionType(wastageItem.type === "raw" ? "raw_material" : "finished_goods");
              setShowVariation(wastageItem?.variation_name !== null ? true : false);              
              let rowArr=[];
              if(wastageItem && wastageItem.stock_wastage_details.length > 0){
                  wastageItem.stock_wastage_details.map((item)=>{                
                  rowArr.push({
                    item_id: item.id,                 
                    item_name: item.item_name,
                    qty: roundOffStock(item.qty),
                    unit_id:item.unit_id,
                    unit_name:item.unit_name || "Pcs",
                  })
                })
                setNewRow([...rowArr]);
              }
            }
          }
          setLoading(false);
        } catch(e) {
          console.log("Error==>",e)
        }
    }

    useEffect(() => {
      if(params.id && branchForListSearch && foodForPOS){
        getSpecificWastage();
      }
    }, [params.id, branchForListSearch, foodForPOS]);                      

    return (
      <>
        <Helmet>
          <title>{_t(t("View Wastage Item"))}</title>
        </Helmet>
  
        {/* main body */}
        <main id="main" data-simplebar>
          <div className="container-fluid">
            <div className="row t-mt-10 gx-2">
              {/* left Sidebar */}
              <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                <ManageSidebar />
              </div>
              {/* left Sidebar ends */}
  
              {/* Rightbar contents */}
              <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
                <div className="t-bg-white">
                  <div
                    className="fk-scroll--pos-menu table-bottom-info-hide"
                    data-simplebar
                  >
                    <div className="t-pl-15 t-pr-15">
                      <CustomSpinLoader loading={loading}/>
                      {/* Loading effect */}
                      {/* {loading === true ? (
                        tableLoading()
                      ) : ( */}
                        <div key="smtp-form">
                          <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                            <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                              <ul className="t-list fk-breadcrumb">
                                <li className="fk-breadcrumb__list">
                                  <span className="t-link fk-breadcrumb__link text-capitalize">
                                    {_t(t("View Wastage Item"))}
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-6 col-lg-7">
                              <div className="row gx-3 align-items-center"></div>
                            </div>
                          </div>
  
                          {/* Form starts here */}
                          <form
                            className="card border-0 shadow-sm mx-3 mb-4 table-text"
                          >
                            <div className="card-body p-3">
                              {/* Row 1: Document Metadata & Type Selection */}
                              <div className="row g-2 align-items-end mb-2">
                                <div className="form-group col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                                  <label
                                    htmlFor="document_no"
                                    className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                    style={{ fontSize: "11px", color: "#000" }}
                                  >
                                    {_t(t("Document no"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    readOnly
                                    type="text"
                                    className="form-control form-control-sm table-text"
                                    id="document_no"
                                    name="document_no"
                                    placeholder="Auto no"
                                    required
                                    value={newWastage?.document_no}
                                    style={{ height: "34px" }}
                                  />
                                </div>

                                <div className="form-group col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                                  <label
                                    htmlFor="document_date"
                                    className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                    style={{ fontSize: "11px", color: "#000" }}
                                  >
                                    {_t(t("Document Date"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <DatePicker
                                    readOnly
                                    selected={newWastage.documentDate || ""}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control form-control-sm table-text"
                                    placeholderText={_t(t("document date"))}
                                    shouldCloseOnSelect={false}
                                  />
                                </div>

                                <div className="form-group col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-2">
                                  <label
                                    htmlFor="branch"
                                    className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                    style={{ fontSize: "11px", color: "#000" }}
                                  >
                                    {_t(t("Branch"))}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <Select
                                    options={branchForSearch ? branchForSearch : []}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={newWastage.branch || null}
                                    classNamePrefix="select"
                                    maxMenuHeight="200px"
                                    styles={customStyle}
                                    placeholder={_t(t("Please select a branch")) + ".."}
                                    isDisabled={true}
                                  />
                                </div>

                                <div className="form-group col-xl-4 col-lg-4 col-md-12 mb-2">
                                  <label
                                    className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                    htmlFor="remarks"
                                    style={{ fontSize: "11px", color: "#000" }}
                                  >
                                    {_t(t("Remarks"))}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm table-text"
                                    id="remarks"
                                    name="remarks"
                                    value={newWastage.remarks || ""}
                                    placeholder={_t(t("Remarks"))}
                                    readOnly
                                    style={{ height: "34px" }}
                                  />
                                </div>
                              </div>

                              {/* Row 2: Type, Category, Item, Quantity in One Straight Line */}
                              <div className="row g-2 align-items-end mb-2">
                                <div className="form-group col-xl-3 col-lg-3 col-md-5 mb-2">
                                  <label
                                    className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                    style={{ fontSize: "11px", color: "#000" }}
                                  >
                                    {_t(t("Type"))}
                                  </label>
                                  <div
                                    className="d-flex align-items-center bg-light rounded px-2 border"
                                    style={{ height: "34px" }}
                                  >
                                    <div className="form-check custom-radio mb-0 d-flex align-items-center mr-3">
                                      <input
                                        readOnly
                                        type="radio"
                                        className="form-check-input pointer-cursor mt-0"
                                        id="raw_material"
                                        name="raw_material"
                                        value="raw_material"
                                        checked={optionType === "raw_material"}
                                      />
                                      <label
                                        className={`form-check-label cursor-pointer ml-1 mb-0 sm-text ${optionType === "raw_material" ? "font-weight-bold" : ""}`}
                                        htmlFor="raw_material"
                                        style={{ fontSize: "12px", color: "#000" }}
                                      >
                                        {_t(t("Raw Material"))}
                                      </label>
                                    </div>

                                    <div className="form-check custom-radio mb-0 d-flex align-items-center">
                                      <input
                                        readOnly
                                        type="radio"
                                        className="form-check-input pointer-cursor mt-0"
                                        id="finished_goods"
                                        name="finished_goods"
                                        value="finished_goods"
                                        checked={optionType === "finished_goods"}
                                      />
                                      <label
                                        className={`form-check-label cursor-pointer ml-1 mb-0 sm-text ${optionType === "finished_goods" ? "font-weight-bold" : ""}`}
                                        htmlFor="finished_goods"
                                        style={{ fontSize: "12px", color: "#000" }}
                                      >
                                        {_t(t("Finished Goods"))}
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                {optionType === "finished_goods" && (
                                  <>
                                    <div className="form-group col-xl-2 col-lg-2 col-md-4 mb-2">
                                      <label
                                        className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                        style={{ fontSize: "11px", color: "#000" }}
                                      >
                                        {_t(t("Category"))}
                                      </label>
                                      <div
                                        className="d-flex align-items-center bg-light rounded px-2 border"
                                        style={{ height: "34px" }}
                                      >
                                        <div className="form-check custom-radio mb-0 d-flex align-items-center mr-2">
                                          <input
                                            type="radio"
                                            className="form-check-input pointer-cursor mt-0"
                                            id="food_item"
                                            name="food_item"
                                            value="food_item"
                                            checked={optionFG === "food_item"}
                                            readOnly
                                          />
                                          <label
                                            className={`form-check-label cursor-pointer ml-1 mb-0 sm-text ${optionFG === "food_item" ? "font-weight-bold" : ""}`}
                                            htmlFor="food_item"
                                            style={{ fontSize: "12px", color: "#000" }}
                                          >
                                            {_t(t("Food"))}
                                          </label>
                                        </div>

                                        <div className="form-check custom-radio mb-0 d-flex align-items-center">
                                          <input
                                            type="radio"
                                            className="form-check-input cursor-pointer mt-0"
                                            id="property_item"
                                            name="property_item"
                                            value="property_item"
                                            checked={optionFG === "property_item"}
                                            readOnly
                                          />
                                          <label
                                            className={`form-check-label cursor-pointer ml-1 mb-0 sm-text ${optionFG === "property_item" ? "font-weight-bold" : ""}`}
                                            htmlFor="property_item"
                                            style={{ fontSize: "12px", color: "#000" }}
                                          >
                                            {_t(t("Property"))}
                                          </label>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="form-group col-xl-4 col-lg-4 col-md-5 mb-2">
                                      <label
                                        className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                        style={{ fontSize: "11px", color: "#000" }}
                                      >
                                        {_t(t(optionFG === "food_item" ? "Food Item" : "Property Item"))}
                                      </label>
                                      <Select
                                        isDisabled={true}
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                        value={optionFG === "food_item" ? food : property}
                                        classNamePrefix="select"
                                        maxMenuHeight="200px"
                                        styles={customStyle}
                                        placeholder={
                                          optionFG === "food_item"
                                            ? _t(t("Please select food")) + ".."
                                            : _t(t("Please select property item")) + ".."
                                        }
                                      />
                                    </div>

                                    <div className="form-group col-xl-2 col-lg-2 col-md-3 mb-2">
                                      <label
                                        className="control-label font-weight-bold mb-1 text-dark text-uppercase"
                                        style={{ fontSize: "11px", color: "#000" }}
                                      >
                                        {_t(t("Quantity"))}
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm table-text text-center"
                                        value={newWastage?.qty || 1}
                                        placeholder={_t(t("Quantity"))}
                                        disabled={true}
                                        style={{ height: "34px" }}
                                      />
                                    </div>
                                  </>
                                )}
                              </div>

                              {/* Variation display */}
                              {showVariation && (
                                <div className="row g-2 mb-2">
                                  <div className="col-12">
                                    <div className="d-flex align-items-center flex-wrap py-1 px-3 bg-light rounded border">
                                      <span
                                        className="font-weight-bold mr-3 text-dark text-uppercase"
                                        style={{ fontSize: "11px", letterSpacing: "0.3px", color: "#000" }}
                                      >
                                        <i className="fa fa-tags mr-1"></i> {_t(t("Variation"))}:
                                      </span>
                                      <div className="form-check custom-radio mb-0 d-flex align-items-center">
                                        <input
                                          className="form-check-input cursor-pointer mt-0"
                                          type="radio"
                                          checked={true}
                                          readOnly
                                        />
                                        <label
                                          className="form-check-label ml-1 mb-0 sm-text text-capitalize font-weight-bold text-dark"
                                          style={{ fontSize: "12px", color: "#000" }}
                                        >
                                          {newWastage?.variation}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* Table Section */}
                              <div
                                className="table-responsive border rounded bg-white mt-1 pr-1"
                                style={{ maxHeight: "22rem", overflow: "auto" }}
                              >
                                <table className="table table-bordered-sm table-hover mb-0">
                                  <thead className="thead-light align-middle sticky-top" style={{ zIndex: 1 }}>
                                    <tr>
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border py-2"
                                        style={{ width: "50%" }}
                                      >
                                        <span style={{ fontWeight: 600 }}>{_t(t("Item"))}</span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border py-2"
                                        style={{ width: "25%" }}
                                      >
                                        <span style={{ fontWeight: 600 }}>{_t(t("Qty"))}</span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border py-2"
                                        style={{ width: "25%" }}
                                      >
                                        <span style={{ fontWeight: 600 }}>{_t(t("Unit"))}</span>
                                      </th>
                                    </tr>
                                  </thead>
                                  {newRow && newRow.length > 0 ? (
                                    <tbody className="align-middle">
                                      {newRow.map((item, index) => {
                                        return (
                                          <tr className="align-middle" key={index}>
                                            <td className="table-text text-capitalize align-middle text-center">
                                              {item.item_name}
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center">
                                              <input
                                                type="number"
                                                step={qtyAmountPoints()}
                                                min="0"
                                                onKeyDown={(evt) =>
                                                  ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) &&
                                                  evt.preventDefault()
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control text-center table-Input table-text py-0"
                                                style={{ height: "30px" }}
                                                id={item.id}
                                                name={item.id}
                                                value={item.qty || ""}
                                                placeholder="Qty"
                                                required
                                                disabled={true}
                                              />
                                            </td>

                                            <td className="table-text text-capitalize align-middle text-center">
                                              {item.unit_name}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  ) : (
                                    <tbody>
                                      <tr>
                                        <td colSpan={3} className="text-center py-4 text-muted sm-text">
                                          <i className="fa fa-info-circle mr-1"></i>{" "}
                                          {_t(t("No items found for this record."))}
                                        </td>
                                      </tr>
                                    </tbody>
                                  )}
                                </table>
                              </div>

                              {/* Footer Action Buttons */}
                              <div className="d-flex justify-content-end align-items-center mt-3 pt-2 border-top">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-light border rounded px-3 font-weight-bold"
                                  onClick={() => history.push("/dashboard/manage/stock/wastage-food")}
                                  style={{ height: "34px" }}
                                >
                                  <i className="fa fa-arrow-left mr-1" aria-hidden="true"></i> {_t(t("Back"))}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      {/* )} */}
                    </div>
                  </div>
                </div>
              </div>
              {/* Rightbar contents end*/}
            </div>
          </div>
        </main>
        {/* main body ends */}
      </>
    );
}

export default WastageFoodView